// node modules
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// actions
import { getCheckoutsArchive } from '../../../redux/checkouts/archives/actions';
// Constants
import { checkoutArchiveColumns } from '../../../enums/columns/checkoutsArchiveReservation';
// Components
import Table from '../../../components/table';
import ReservesCheckoutArchiveModal from './ReservesCheckoutArchiveModal';
import DetailsCheckoutArchiveModal from './DetailsCheckoutArchiveModal';
import DatePicker from '../../../components/FormElements/DatePicker/DatePicker';
// Enums
import ENUMS from '../../../enums';
// Utils
import submitForm from '../../../utils/submitForm';

const pageSize = 10;
let selectedRecordId;
let selectedCafeName = '';

function CheckoutsArchive() {
  let formRefrence = useRef();
  const dispatch = useDispatch();
  const state = useSelector(state => state.checkoutsArchiveReducer);
  const [currentPage, setCurrentPage] = useState(1);
  const [showModal, setShowModal] = useState('');
  const [sort, setSort] = useState({ sortType: 'desc', sortBy: 'checkoutAt', sortQuery: '', filterQuery: '' });
  const [formData, setFormData] = useState({ cafeNamePart: '', checkoutStart: '', checkoutEnd: '' });
  const [error, setError] = useState('');

  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&sort=${sort.sortQuery || 'checkoutAt-desc'}`;
      if (sort.filterQuery) {
        query += '&' + sort.filterQuery;
      }
      return query;
    }
  };

  const onPageChanged = pageNumber => {
    setCurrentPage(pageNumber);
    const query = buildSearchQuery(pageNumber, pageSize);
    dispatch(getCheckoutsArchive(query));
  };

  const checkoutReserves = item => {
    setShowModal('reservation');
    selectedRecordId = item.id;
    selectedCafeName = item.cafeName;
  };

  const showDetails = item => {
    setShowModal('details');
    selectedRecordId = item.id;
    selectedCafeName = item.cafeName;
  };

  const sortTable = (columnName) => {
    const sortType = sort.sortType === 'asc' ? 'desc' : 'asc';

    const sortQuery = `${columnName}-${sortType}`;

    setSort({ ...sort, sortType, sortBy: columnName, sortQuery });

  };

  const filterAndSort = () => {
    let searchQuery = buildSearchQuery(currentPage, pageSize);
    dispatch(getCheckoutsArchive(searchQuery));
  };

  const applyFilters = (event) => {
    event.preventDefault();
    if (!error) {
      const queryString = submitForm(event);
      setSort({ ...sort, filterQuery: queryString });
    }
  };

  const resetForm = () => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setFormData({ cafeNamePart: '', checkoutStart: '', checkoutEnd: '' });
    setSort({ ...sort, filterQuery: '' });
    setError('');
  };

  const handleEndDataChange = (val) => {
    setFormData({ ...formData, checkoutEnd: val });
    if (formData.checkoutStart > val) {
      setError('مقدار وارد شده کوچکتر از تاریخ شروع می باشد');
    } else {
      setError('');
    }
  };

  const handleStartDateChange = (val) => {
    setFormData({ ...formData, checkoutStart: val });
    if (val <= formData.checkoutEnd) {
      setError('');
    } else if (val > formData.checkoutEnd) {
      setError('مقدار وارد شده کوچکتر از تاریخ شروع می باشد');
    }
  };

  // useEffect(() => {
  //   sortTable(sort.sortBy);
  // }, []);

/*  useEffect(() => {
    const sortQuery = `${sort.sortBy}-${sort.sortType}`;
    setSort({ ...sort, sortQuery });
  }, [sort.sortType]);*/

  // useEffect(() => {
  //   setCurrentPage(currentPage);
  //   filterAndSort();
  // }, [sort.sortQuery]);

  useEffect(() => {
    setCurrentPage(currentPage);
    filterAndSort();
  }, [sort]);

  return (
    <div>
      <h3 className='text-muted py-4'>
        <div className='text-right'>
          {locales('titles.checkoutReportArchive')}
        </div>
      </h3>
      <div className='panel-heading'>
        <i className='fas fa-list-alt px-1'></i>
        لیست آرشیو تسویه حسابها&zwnj;
      </div>
      <div className='filter-part'>
        <form
          onReset={event => resetForm(event)}
          onSubmit={event => applyFilters(event)}
          id="form"
          ref={formRefrence}
          className="my-4"
        >
          <div className="col-12 d-flex justify-content-between">
            <label className="col-1 text-right filter-field-label">{locales('fields.cafe.name')}</label>
            <input
              name="cafeNamePart"
              type="text"
              value={formData.cafeNamePart}
              onChange={event => setFormData({ ...formData, cafeNamePart: event.target.value })}
              className="form-control col-3"
              placeholder={locales('fields.cafe.name')}
              maxLength={ENUMS.MAX_LENGTH.cafeName}
              id="cafeNameInput"
            />
            <span className="col-2 text-right filter-field-label">{locales('titles.checkoutAt')}</span>
            از
            <DatePicker
              marge={true}
              placeholder="تاریخ شروع"
              name="checkoutStart"
              className="form-control col-2"
              value={formData.checkoutStart}
              onChange={(value) => handleStartDateChange(value)}
            />
            تا
            <DatePicker
              marge={true}
              placeholder="تاریخ پایان"
              name="checkoutEnd"
              className="form-control col-2"
              value={formData.checkoutEnd}
              onChange={v => handleEndDataChange(v)}
            />
          </div>
          {error && <div style={{ color: 'red', fontSize: '0.8rem', textAlign: 'end' }}>{error}</div>}
          <br/>
          <div style={{ textAlign: 'center' }}>
            <input
              name="resetButton"
              type="reset"
              value={locales('fields.reset')}
              className="btn btn-danger w-5 mx-2"
              maxLength="10"
            />
            <button
              type="submit"
              id="apply-filter-btn-cafe"
              className="btn btn-success w-5 mx-2"
              name="filter"
            >
              {locales('fields.applyFilters')}
            </button>
          </div>
        </form>
      </div>
      <Table
        columns={checkoutArchiveColumns}
        
        dataSource={state.checkoutsArchive}
        loading={state.getCheckoutsArchiveLoading}
        action={{
          checkoutReserves: checkoutReserves,
          showDetails: showDetails,
        }}
        sort={{ type: sort.sortType, action: sortTable }}
        pagination={{
          currentPage: currentPage,
          pageSize: pageSize,
          totalCount: state.checkoutArchive.totalRecords,
          onPageChange: onPageChanged,
        }}
      />
      {showModal === 'reservation' && (
        <ReservesCheckoutArchiveModal
          showReserveModal={showModal}
          setShowModal={setShowModal}
          selectedRecordId={selectedRecordId}
          selectedCafeName={selectedCafeName}
        />
      )}
      {showModal === 'details' && (
        <DetailsCheckoutArchiveModal
          showDetailsModal={showModal}
          setShowModal={setShowModal}
          selectedRecordId={selectedRecordId}
          selectedCafeName={selectedCafeName}
        />
      )}
    </div>
  );
}

export default CheckoutsArchive;
